import { CheckoutSuccess } from 'assets/images'
import { DataContext } from 'contexts/DataContextContainer'
import queryString from 'query-string'
import { useContext, useEffect } from 'react'
import { Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { CheckoutCompleteContainer } from './style'

function CheckoutComplete() {
  const { t, i18n } = useTranslation()
  const { setLang } = useContext(DataContext)
  const location = useLocation()
  const { language, email } = queryString.parse(location.search)

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language)
      setLang(language)
      localStorage.setItem('lang', language)
    }
  }, [i18n, language, setLang])

  return (
    <CheckoutCompleteContainer>
      <div className="img-container">
        <Image src={CheckoutSuccess} />
      </div>
      <h1 className="title">{t('welcome_to_anecdobio')}</h1>
      <h3 className="description">{t('checkout_complete_body', { email })}</h3>
    </CheckoutCompleteContainer>
  )
}

export default CheckoutComplete
